import {Entity} from "@backstage/catalog-model";
import {GITHUB_ACTIONS_ANNOTATION} from "./getProjectNameFromEntity.ts";


/** @public */
export const isGithubActionsAvailable = (entity: Entity) =>
    Boolean(entity.metadata.annotations?.[GITHUB_ACTIONS_ANNOTATION]);
